import { render } from "./ReportPage.vue?vue&type=template&id=3a1750d1"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"

import "./ReportPage.vue?vue&type=style&index=0&id=3a1750d1&lang=css"

import exportComponent from "E:\\Proj\\Apps\\tabarok_management\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__